/**
 * Z-Suite marka kimliği — altın monogram + wordmark (CLAUDE.md §11).
 * Premium, koyu, amber vurgulu.
 */

export function Monogram({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label="Z-Suite"
      className="shrink-0"
    >
      <defs>
        <linearGradient id="z-gold" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E2C766" />
          <stop offset="1" stopColor="#C9A227" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="12" fill="#0E1626" stroke="url(#z-gold)" strokeWidth="1.25" strokeOpacity="0.5" />
      {/* stilize Z */}
      <path
        d="M15 16.5h18l-15 15h15"
        stroke="url(#z-gold)"
        strokeWidth="2.75"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />
      <circle cx="33" cy="16.5" r="1.6" fill="#E2C766" />
    </svg>
  );
}

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Monogram size={36} />
      <span className="font-serif text-xl tracking-tight text-slate-50">
        Z<span className="text-gold">·</span>Suite
      </span>
    </div>
  );
}
